import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../Context/AuthContext/AuthContext'
import { ThemeContext } from '../Context/ThemeContext/ThemeContext'
import { db, storage } from '../Firebase/firebase'
import { useHistory } from 'react-router-dom'
import firebase from 'firebase'

import LoadingIcon from '../LoadingIcon/LoadingIcon'

import './CreatePost.css'

const CreatePost = () => {
  //* on creating account the details required for the account are stored in the currentuser(username,profilepic)
  const history = useHistory()

  const { isLight } = useContext(ThemeContext)
  const { currentUser} = useContext(AuthContext)

  const [platforms, setPlatforms] = useState([])
  const [platformSelect, setPlatformSelect] = useState('All')
  const [title, setTitle] = useState('')
  const [text, setText] = useState('')

  const [imgPath, setImgPath] = useState()
  const [imgURL, setImgURL] = useState()

  const [loading, isLoading] = useState(false)

  const handlePostImgUpload = e => {
    if(e.target.files[0]){
      setImgPath(e.target.files[0])
    }
  }

  const handleImgUpload = e => {
    isLoading(true)
    e.preventDefault()
    if(imgPath){
      if((text.length < 1) && (title.length < 1)){
        const uploadImg = storage.ref(`post/${imgPath.name}`).put(imgPath)

        uploadImg.on(
          'state_changed',
          (snapshot) => {
            let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log(progress)
          },
          (error) => {
            alert(error.message)
          },
          () => {
            uploadImg.snapshot.ref.getDownloadURL()
              .then(downloadURL => {
                
                setImgURL(downloadURL)
                db.collection('posts').add(
                  {
                    imgURL: downloadURL,
                    postText: text,
                    postTitle: title,
                    userName: currentUser.displayName,
                    profilePic: currentUser.photoURL,
                    platform: platformSelect,
                    createdAt: firebase.firestore.FieldValue.serverTimestamp()
                  }
                ).then((res) => {
                  isLoading(false)
                  history.push(`/post/${res.id}`)
                })
  
              })
          }
        )
      } else {
        alert("Title and para are mandatory")
        isLoading(false)
      }
      
    } 
    else{
      if((text.length < 1) && (title.length <1)){

        db.collection('posts').add(
          {
            postText: text,
            postTitle: title,
            userName: currentUser.displayName,
            profilePic: currentUser.photoURL,
            platform: platformSelect,
            createdAt: firebase.firestore.FieldValue.serverTimestamp()
          }
        ).then((res) => {
          history.push(`/post/${res.id}`)
        })
      } else {
        alert("Title and para are mandatory")
        isLoading(false)
      }
    }
  }


  useEffect(() => {
    db.collection('platform').orderBy("createdAt").onSnapshot(snapshot => {
      setPlatforms(snapshot.docs)
    })
      
  }, [])
  return (
    <section className={`create-post ${isLight ? "" : "dark"}`}>
      <div className="create-post__container">
        {loading ? (
          <LoadingIcon />
        ) : (
          <form className={`create-post__form ${isLight ? "" : "dark"}`}>
            <h2 className="create-post__header">Create Post</h2>
            <select className="create-post__dropdown" value={platformSelect} onChange={e => setPlatformSelect(e.target.value)}>
              {platforms.map(platform => {
                const platformName = platform.data().platformName
                return(
                  <option value={platformName}>{platformName}</option>
                )
              })}
            </select>
            <div className="create-post__form__container">
              <input type="text" required value={title} onChange={e => setTitle(e.target.value)} className="create-post__form__container__title"/>
              <label>Title</label>
            </div>
            <div className="create-post__form__container">
              <input type="file" onChange={handlePostImgUpload} className="create-post__img-input"/>
            </div>
            <div className="create-post__form__container">
              <textarea type="text" required value={text} onChange={e => setText(e.target.value)}/>
              <label>Text</label>
            </div>
            <button className="create-post__btn" type="submit" onClick={handleImgUpload}>Submit</button>

          </form>
        )}
        
      </div>
    </section>
  )
}

export default CreatePost
